import { createSlice } from "@reduxjs/toolkit";
import { attendanceReducer } from "../Reducer/attendanceReducer";

const initialState = {
  loading: false,
  syncing: false,
  savingConfig: false,
  calendar: {},
  logs: [],
  logsLoading: false,
  logsPagination: {
    page: 1,
    limit: 50,
    total: 0,
  },
  dashboardTodayLogs: [],
  dashboardTodayLogsLoading: false,
  dashboardYesterdayLogs: [],
  dashboardYesterdayLogsLoading: false,
  machineUsers: [],
  machineUsersLoading: false,
  machineUsersMutating: false,
  config: null,
  webhookStatus: null,
  lastSyncAt: null,
  analyticsOverview: null,
  analyticsHistory: null,
  analyticsLoading: false,
  teamWeek: null,
  teamWeekLoading: false,
  holidaysList: [],
  holidaysLoading: false,
};

const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    attendanceReducer(builder);
  },
});

export default attendanceSlice.reducer;
